export const integrationsRoutes = [
  {
    name: 'integrations',
    path: '/integrations',
    component: () => import('@/modules/integrations/views/IntegrationsView.vue'),
    meta: {
      locationTypes: ['location', 'singleLocation']
    }
  },
  {
    name: 'integrationValidate',
    path: '/integrations/:id/validate',
    component: () => import('@/modules/integrations/views/IntegrationValidatorView.vue'),
    meta: {
      locationTypes: ['location', 'singleLocation']
    }
  }
]
